import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {MatPaginator} from '@angular/material/paginator';
import {FormBuilder} from '@angular/forms';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AuthService} from '../../../../shared/services/auth.service';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {CommissionImportRow} from '../../../../shared/interface/commission-import-row';
import {CommissionImportRowService} from '../../../../shared/services/commission-import-row.service';

@Component({
  selector: 'app-commission-details',
  templateUrl: './commission-details.component.html',
  styleUrls: ['./commission-details.component.scss']
})
export class CommissionDetailsComponent implements OnInit, OnDestroy {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  commissionImportRowId: string;
  commissionImportRowObject?: CommissionImportRow;
  commissionImportRow: ReplaySubject<CommissionImportRow> = new ReplaySubject<CommissionImportRow>(1);
  userPermissions: ReplaySubject<UserPermissions>;
  modify = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private commissionImportRowService: CommissionImportRowService,
    private snack: MatSnackBar,
    private fb: FormBuilder,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.commissionImportRowId = params.id;
        this.loadCommissionImportRow();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadCommissionImportRow(): void {
    this.commissionImportRowService.get(this.commissionImportRowId).subscribe((commissionImportRow: CommissionImportRow) => {
      this.commissionImportRow.next(commissionImportRow);
      this.commissionImportRowObject = commissionImportRow;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych prowizji', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
